import { render } from "./forumReplyList.vue?vue&type=template&id=117537b1"
import script from "./forumReplyList.vue?vue&type=script&lang=js"
export * from "./forumReplyList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__